import requestAnimFrame from './raf-polyfill';

// easing functions http://goo.gl/5HLl8
const easeInOutQuad = function (t, b, c, d) {
  t /= d/2;
  if (t < 1) {
    return c/2*t*t + b;
  }
  t--;
  return -c/2 * (t*(t-2) - 1) + b;
};

const scrollTo = function(element, to, duration = 400, callback) {
  var start = element.scrollTop,
    change = to - start,
    currentTime = 0,
    increment = 10;

  var animateScroll = function() {
    currentTime += increment;
    element.scrollTop = easeInOutQuad(currentTime, start, change, duration);

    if (currentTime < duration) {
      requestAnimFrame(animateScroll);
    } else {
      if (callback && typeof callback === 'function') {
        callback();
      }
    }
  };
  animateScroll();
};

export default scrollTo;



// WEBPACK FOOTER //
// ./src/main/js/utils/ScrollTo.js